import React from 'react';

const publicityCommittee = [
  {
    name: "Prof. Deepak Kumar",
    institute: "Punjab Engineering College, Chandigarh, India"
  },
  {
    name: "Prof. Hemant Kumar Singh",
    institute: "SMS Institute of Technology, Lucknow, India"
  },
  { 
    name: "Prof. Bhawna", 
    institute: "SET, CGC University, Mohali" 
  },
  { 
    name: "Prof. Sonia Bhukra", 
    institute: "SET, CGC University, Mohali" 
  },
  { 
    name: "Prof. Puneet", 
    institute: "SET, CGC University, Mohali" 
  },
];

const Publicity = () => {
  return (
    <div>
      
      <div className='container mx-auto p-4 pt-20 sm:pt-4'>
        <div className="flex flex-wrap w-full relative flex-col flex-auto py-8 px-9">
          <h1 className="mb-2 text-[1.75rem] font-bold text-dark text-center text-4xl uppercase">
          Publicity Committee
          </h1>
        </div>
        <div className="flex w-full text-2xl">
          <ul className="list-disc pl-5">
            {publicityCommittee.map((member, index) => (
              <li key={index} className="text-lg sm:text-2xl mb-4">
                {member.name}, {member.institute}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Publicity;